<template>
    <script-embed-group>
        <template v-slot:meta>
			<v-col cols="12">
				<v-text-field v-model="mValue.Title" label="Title"></v-text-field>
			</v-col>
			<v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
				<NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
			</v-col>
        </template>

        <template v-slot:Embeds>
			<DraggableGroupItems
				v-model="mValue.Embeds"
				items-label="Embed"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<text-editor v-model="item.pretext"></text-editor>
					<v-textarea v-model="item.code" label="Code"></v-textarea>
					<text-editor v-model="item.text"></text-editor>
				</template>
			</DraggableGroupItems>
        </template>
    </script-embed-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import ScriptEmbedGroup from '@/CMS/views/ContentBlocks/ScriptEmbedGroup.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
	components: {
        TextEditor,
        ScriptEmbedGroup,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
    props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'Embeds', // override Mixin
        }
    },
    methods: {
        reset () { // override Mixin
			const value = { ...this.mValue }
			if (typeof value.Embeds === 'undefined') {
				value.Embeds = [this.getNewItem()]
			}
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 4
			}
			value.Embeds.map((embed) => {
				const item = { ...embed }
				if (typeof item.id === 'undefined') {
					this.counter = this.counter + 1
					item.id = this.counter
				}
				return item
			})
			this.mValue = value
        },
		getNewItem () { // override Mixin
			this.counter = this.counter + 1
			return {
				id: this.counter,
				title: '',
				pretext: '',
                code: '<script><\/script>',
				text: '',
			}
        },
    },
}
</script>
